import { useMemo } from 'react'
import { ArrowPathRoundedSquareIcon, MicrophoneIcon, CloudArrowUpIcon } from '@heroicons/react/24/solid'
import { useHistory } from '../../../../providers/HistoryProvider'
import { isMobileDevice } from '../../../../utils/deviceUtils'
import TemplatePicker from '../../../templates/TemplatePicker'
import { TemplateType } from '@neum/frontend-shared/constants/templateData'
import { TemplateObject } from '../../../../utils/TemplateObject'

interface NewNoteInitialSelectionProps {
    template: TemplateObject | undefined;
    setTemplate: (template: TemplateObject | undefined) => void;
    handleUploadRecording: () => void;
    handleReuseExistingRecordings: () => void;
}

export const NewNoteInitialSelection: React.FC<NewNoteInitialSelectionProps> = ({ 
    template,
    setTemplate,
    handleUploadRecording,
    handleReuseExistingRecordings,
}) => {
    const {
        handleAddToSessionNote,
        activeSession,
    } = useHistory();

    const isMobile = useMemo(isMobileDevice, []);

    return (
        <div className="flex flex-col gap-3 w-full">
            <TemplatePicker
                template={template} 
                templateIdForce={template ? `${template.organization}/${template.id}` : undefined} 
                setTemplate={setTemplate} 
                className={""} 
                pickerWidth={'w-full'} 
                templateBackground={"bg-white"} 
                type={TemplateType.MEDICAL} 
                pickerDirection={isMobile ? "above" : "below"} 
                externalTemplateId={activeSession?.external_template_id}
            />
            <button
                type="button"
                onClick={() => handleAddToSessionNote(undefined,  template ? `${template.organization}/${template.id}` : undefined)}
                className="inline-flex w-full items-center justify-center gap-x-2 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
                <MicrophoneIcon className="h-5 w-5" aria-hidden="true" />
                Record now
            </button>
            <button
                type="button"
                onClick={handleUploadRecording}
                className="inline-flex w-full items-center justify-center gap-x-2 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
                <CloudArrowUpIcon className="h-5 w-5" aria-hidden="true" />
                Upload recording file
            </button>
            <button
                type="button"
                onClick={handleReuseExistingRecordings}
                className="inline-flex w-full items-center justify-center gap-x-2 rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
                <ArrowPathRoundedSquareIcon className="h-5 w-5" aria-hidden="true" />
                Reuse existing recordings
            </button>
        </div>
    )
};